"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports["default"] = (function (existingSwapHistory, importedSwapHistory) {
    var usedSwapIds = [];
    var dirtyJoin = __spreadArray(__spreadArray([], __read((existingSwapHistory || [])), false), __read((importedSwapHistory || [])), false);
    var cleanSwapHistory = [];
    for (var i = dirtyJoin.length - 1; i >= 0; i--) {
        // Iterate backwards to prioritise imported swaps
        var swapOperation = dirtyJoin[i];
        if (usedSwapIds.includes(swapOperation.swapId))
            continue;
        usedSwapIds.push(swapOperation.swapId);
        cleanSwapHistory.push(swapOperation);
    }
    return cleanSwapHistory;
});
//# sourceMappingURL=joinSwapHistories.js.map